import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useInventory } from "../hooks/useInventory";
import { T } from "./T";

const LashingTable = () => {
  const { dbLashings, dbBipodLashings, dbTripodLashings, dbScaffoldLashings } =
    useInventory();

  return (
    <TableContainer
      component={Paper}
      sx={{
        backgroundColor: "primary.light",
        color: "primary.contrastText",
        overflowY: "auto",

        "& th": {
          fontWeight: "bold",
          backgroundColor: "primary.main",
        },

        "& td": {
          fontWeight: "bold",
        },
      }}
    >
      <Table aria-label="Pole Table">
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <T str="Type" />
            </TableCell>
            <TableCell align="left">#</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key="lashings">
            <TableCell>
              <T str="Square Lashing" />
            </TableCell>
            <TableCell>{dbLashings?.length}</TableCell>
          </TableRow>
          <TableRow key="bipodLashings">
            <TableCell>
              <T str="Bipod Lashing" />
            </TableCell>
            <TableCell>{dbBipodLashings?.length}</TableCell>
          </TableRow>
          <TableRow key="tripodLashings">
            <TableCell>
              <T str="Tripod Lashing" />
            </TableCell>
            <TableCell>{dbTripodLashings?.length}</TableCell>
          </TableRow>
          <TableRow key="scaffoldLashings">
            <TableCell>
              <T str="Scaffold Lashing" />
            </TableCell>
            <TableCell>{dbScaffoldLashings?.length}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LashingTable;
